<template>
  <quiz-layout>
    <template #sidebar>
      <div class="sidebar__menu">
        <router-link class="menu__item" :to="`/lessons`">
          <div class="item__title">Lessons</div>
        </router-link>
        <router-link class="menu__item" :to="`/users`">
          <div class="item__title">Users</div>
        </router-link>
      </div>
    </template>
    <template>
      <div class="content__title">Lessons</div>
      <div class="content__group">
        <div class="group__item" v-for="(item, key) in lessons" :key="key">
          <div class="group__title">
            <router-link
              :to="`/quiz-edit/${item.slug}`"
            >
              {{ item.name }}
            </router-link>
          </div>
          <!-- <router-link :to="`/quiz/${item.slug}`"> -->
          <!-- Goto Admin Link -->
          <div class="group__action"
               :to="`/quiz-edit/${item.slug}`">View</div>
          <!-- </router-link> -->
        </div>
      </div>
    </template>
  </quiz-layout>
</template>
<script>
import { AccountService } from "../data/services/account.service";
import QuizLayout from "../layout/QuizLayout.vue";
export default {
  components: { QuizLayout },
  data() {
    return {
      lessons: [],
    };
  },
  mounted() {
    this.getLessons();
  },
  methods: {
    async getLessons() {
      const accountService = new AccountService();
      const lesson = await accountService.getLessons();
      this.lessons = lesson;
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  &__title {
    font-weight: 500;
    font-size: 22px;
    line-height: 25px;
    margin-bottom: 12px;
  }
  &__group {
    padding: 20px;
    width: 100%;
    background: white;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
  }
}
.group {
  &__item {
    display: flex;
    align-content: center;
    justify-content: space-between;
    + .group__item {
      margin-top: 10px;
    }
  }
  &__title {
    font-size: 16px;
    align-self: center;
  }
  &__action {
    cursor: pointer;
    font-size: 14px;
    padding: 4px 15px;
    background: #f1bc04;
    color: #ffffff;
    border-radius: 20px;
  }
}

.sidebar {
  &__menu {
    display: flex;
    flex-direction: column;
  }
}

.menu {
  &__item {
    display: flex;
    cursor: pointer;
    align-items: center;
    + .menu__item {
      margin-top: 10px;
    }
  }
}

.item {
  &__icon {
    width: 26px;
    margin-right: 15px;
    svg {
      width: 100%;
    }
  }
  &__title {
    color: #ffffff;
    font-size: 20px;
    line-height: 24px;
    &:hover {
      color: #f1bc04;
    }
  }
}
</style>
